import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const signIn = createAsyncThunk('SignIn', async (data) => {
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'user_login',
            data: {
                "user_id": data?.phone,
                "user_password": data?.password
            },
            headers: { "Content-Type": "application/json" }
        })
        return res
    } catch (error) {
        return error.response
    }
})